import { ArrayPath, Path } from 'react-hook-form';

import { CampaignForm } from '../utils';

/** Builds a campaign sender sub-form field path, centralizing the string→`Path<CampaignForm>` cast. Omit `field` for the sender object itself. */
export const senderFieldPath = (senderPath: string, field?: string): Path<CampaignForm> =>
  (field ? `${senderPath}.${field}` : senderPath) as Path<CampaignForm>;

/** Like {@link senderFieldPath} but typed as `ArrayPath<CampaignForm>` for `useFieldArray`. */
export const senderArrayFieldPath = (senderPath: string, field: string): ArrayPath<CampaignForm> =>
  `${senderPath}.${field}` as ArrayPath<CampaignForm>;
